class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menuTrigger = this.header?.dataset.menuTrigger || 'click';
    this.closeTimeout = null;
    this.closeDelay = 150; // ms delay before closing menu
    
    if (this.menuTrigger === 'hover' && window.matchMedia('(min-width: 990px)').matches) {
      this.setupHoverBehavior();
    }

    window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => {
      if (e.matches && this.menuTrigger === 'hover') {
        this.setupHoverBehavior();
      } else {
        this.removeHoverBehavior();
      }
    });
  }

  setupHoverBehavior() {
    this.mouseEnterHandler = () => {
      this.clearCloseTimeout();
      this.open();
    };
    
    this.mouseLeaveHandler = () => {
      this.scheduleClose();
    };
    
    this.addEventListener('mouseenter', this.mouseEnterHandler);
    this.addEventListener('mouseleave', this.mouseLeaveHandler);
    
    // Also listen on the content for mouseenter to cancel close
    if (this.content) {
      this.content.addEventListener('mouseenter', () => this.clearCloseTimeout());
      this.content.addEventListener('mouseleave', () => this.scheduleClose());
    }
    
    // Prevent click from toggling when in hover mode
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.clickHandler = (e) => {
      if (this.menuTrigger === 'hover' && window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
      }
    };
    summary.addEventListener('click', this.clickHandler);
    
    // Add hover class to header-menu for CSS targeting
    this.classList.add('header-menu--hover-enabled');
  }

  removeHoverBehavior() {
    if (this.mouseEnterHandler) {
      this.removeEventListener('mouseenter', this.mouseEnterHandler);
      this.removeEventListener('mouseleave', this.mouseLeaveHandler);
    }
    this.classList.remove('header-menu--hover-enabled');
    this.clearCloseTimeout();
  }

  scheduleClose() {
    this.clearCloseTimeout();
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, this.closeDelay);
  }

  clearCloseTimeout() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  open() {
    // Close all other open header menus first
    this.closeOtherMenus();
    
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.classList.add('header-menu--open');
  }

  closeOtherMenus() {
    const allHeaderMenus = document.querySelectorAll('header-menu');
    allHeaderMenus.forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle?.hasAttribute('open')) {
        menu.close();
      }
    });
  }

  close() {
    this.clearCloseTimeout();
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.classList.remove('header-menu--open');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
